module.exports = __webpack_public_path__ + "static/media/beam@2x.dd2c55fb.jpg";